<style lang="stylus" scoped>
    .import-library-container
        width: 480px
        color: var(--text-color-primary)
        .flex-wrap
            display flex
            .word-column
                white-space nowrap
                padding-right 10px
                >p

                    line-height 24px
                    margin-bottom 10px
            .input-column
                flex 1
        .image-model-tab
            display flex
            // min-width 540px
            div+div{
              margin-left: 24px
            }
            div
                font-size 13px
                padding 2px 0px
                cursor pointer
                color var(--text-color-primary)
            .image-tab-active
                color var(--themeColor)
                font-weight: 700;
                border-bottom 2px solid var(--themeColor)
        .image-local
            font-size: 16px
            background-color: var(--bg-color-import-library)
            margin-top: 20px
            border 2px dashed $box-bordercolor
            height 250px
            width 100%
            display flex
            justify-content center
            align-content center
            flex-wrap wrap
            border-radius: $box-radius;
            .image-local-tip
                color var(--text-color-primary-40)
                margin-top: 20px
                width 100%
                text-align center
                line-height 2
                pointer-events none
            .image-local-btn
                background var(--themeColor)
                color #fff;
                height: 36px
                line-height: 36px;
                display: flex;
                align-items: center;
                padding 6px 12px
                border-radius 6px
                cursor pointer
                font-size: 16px
                &:hover
                    background-color: var(--themeHover);
                svg{
                  width: 32px
                  margin-right: 8px
                }
        .OpenLibrary-container
            margin 20px
            width calc(100% - 40px)
            .OpenLibrary-line
                display flex
                justify-content space-around
                margin-bottom 10px
                .input-box
                    flex 1
                    /deep/.ivu-input.ivu-input-small
                        border-radius 0px
                        background-color var(--bg-color-primary)
                        color var(--text-color-primary)
                >p
                    line-height 24px
                    white-space nowrap
                    margin-right 10px
            .OpenLibrary-import
                display flex
                justify-content space-around
                margin-bottom 10px
                .mr10
                    margin-right 10px
                .import-showTitle
                    line-height 24px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                .import-showText
                    flex 1
                    margin-right 10px
                    height 24px
                    line-height 24px
                    text-indent 10px
                    border 1px solid var(--border-color-library-modal-btn)
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                .import-btn
                    width 71px
                    height 24px
                    border 1px solid var(--border-color-library-modal-btn)
                    text-align center
                    line-height 24px
                    font-size 12px
                    cursor pointer
                    user-select none
                    &:hover
                        background-color var(--bg-color-library-btn-import-hover)
                input
                    display none
    .importLibrary-mask
        position fixed
        left 0
        top 0
        width 100vw
        height 100vh
        z-index 30
</style>

<template>
    <div>
        <div class="importLibrary-mask"></div>
        <Dialog :title="$t('title')" :isShow="true" :mask="from !== 'modelClick'" :extra="true" class="import-library-container" @close="close">
            <div class="image-model-tab">
                <div :class="{ 'image-tab-active': activeTab == 1 }" @click="setTab(1)">{{ $t("uploadImg") }}</div>
                <div :class="{ 'image-tab-active': activeTab == 2 }" @click="setTab(2)">{{ $t("uploadFile") }}</div>
                <div :class="{ 'image-tab-active': activeTab == 3 }" @click="setTab(3)">{{ $t("uploadEde") }}</div>
                <div :class="{ 'image-tab-active': activeTab == 4 }" @click="setTab(4)">{{ $t("uploadSvg") }}</div>
            </div>
            <div
                class="image-local"
                v-show="activeTab == 1"
                @dragenter="fileDragenter($event)"
                @dragleave="fileDragleave($event)"
                @dragover="fileDragOver($event)"
                @drop="fileDrop($event, 'img')"
            >
                <div class="image-local-tip">
                    {{ $t("dragImage") }}
                    <br />
                    {{ $t("or") }}
                </div>
                <label class="image-local-btn" for="choosePicture">
                    {{ $t("selectLocalImage") }}
                </label>
                <input style="display: none" id="choosePicture" multiple accept=".bmp, .png, .jpg, .jpeg,  .ico" type="file" @change="addPicture" />
            </div>

            <div class="OpenLibrary-container" v-show="activeTab == 2">
                <div class="OpenLibrary-import">
                    <p class="import-showTitle mr10">{{ $t("edtfile") }}:</p>
                    <div ref="edtText" class="import-showText"></div>
                    <div class="import-btn" @click="importBtn('edt')">{{ $t("importBtn") }}</div>
                    <input ref="edtImporter" type="file" accept=".edt" @change="getEdt($event)" />
                </div>
                <div class="OpenLibrary-import">
                    <p class="import-showTitle mr10">{{ $t("edlfile") }}:</p>
                    <div ref="edlText" class="import-showText"></div>
                    <div class="import-btn" @click="importBtn('edl')">{{ $t("importBtn") }}</div>
                    <input ref="edlImporter" type="file" accept=".edl" @change="getEdl($event)" />
                </div>
            </div>

            <div class="OpenLibrary-container" v-show="activeTab == 3">
                <div class="flex-wrap">
                    <div class="word-column">
                        <p>{{ $t("symbolName") }}:</p>
                        <p class="import-showTitle">{{ $t("imgfile") }}:</p>
                        <p class="import-showTitle">{{ $t("edefile") }}:</p>
                    </div>
                    <div class="input-column">
                        <div class="OpenLibrary-line">
                            <Input class="input-box" v-model="symbolName" size="small" />
                        </div>

                        <div class="OpenLibrary-import">
                            <div ref="imgText" class="import-showText"></div>
                            <div class="import-btn" @click="importBtn('img')">{{ $t("importBtn") }}</div>
                            <input ref="imgImporter" type="file" accept=".jpg,.png,.jpeg" @change="getImg($event)" />
                        </div>
                        <div class="OpenLibrary-import">
                            <div ref="edeText" class="import-showText"></div>
                            <div class="import-btn" @click="importBtn('ede')">{{ $t("importBtn") }}</div>
                            <input ref="edeImporter" type="file" accept=".ede" @change="getEde($event)" />
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="image-local"
                v-show="activeTab == 4"
                @dragenter="fileDragenter($event)"
                @dragleave="fileDragleave($event)"
                @dragover="fileDragOver($event)"
                @drop="fileDrop($event, 'svg')"
            >
                <div class="image-local-tip">
                    {{ $t("dragSvg") }}
                    <br />
                    {{ $t("or") }}
                </div>
                <label class="image-local-btn" for="chooseSvg">
                    {{ $t("selectLocalSvg") }}
                </label>
                <input ref="chooseSvg" style="display: none" id="chooseSvg" multiple accept=".svg" type="file" @change="addPicture($event, 'svg')" />
            </div>

            <div class="dialog-btnbox-normal" v-show="activeTab == 2 || activeTab == 3" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
                <div class="" @click="close()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "./../Dialog.vue";
    import appConfig from "@/public/globalConfig";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class ImportLibrary extends Vue {
        @Inject()
        ["showMessage"];

        @Prop()
        DBName;
        @Prop()
        TBName;
        @Prop()
        TBID;
        @Prop()
        from;
        @Prop()
        type;

        activeTab: number = 1;
        worker: any;
        userWorkerURL: string = appConfig.userWorkerURL;
        edt: any;
        edl: any;

        // ede symbol
        symbolName: string = "";
        imgFile: any;
        edeFile: any;

        setTab(tab) {
            this.activeTab = tab;
        }
        close() {
            this.$emit("closeModal");
        }
        addOverAction() {
            this.$emit("updateShowList", {
                dbName: this.DBName,
                tableID: this.TBID,
            });
            this.close();
        }

        // img file
        fileDragenter(e) {
            (<HTMLInputElement>document.querySelector(".image-local")).style.backgroundColor = "#eeeeee";
        }
        fileDragleave(e) {
            (<HTMLInputElement>document.querySelector(".image-local")).style.backgroundColor = "#fff";
        }
        fileDragOver(e) {
            // 禁止浏览器默认事件
            e.preventDefault();
        }
        fileDrop(e, flag) {
            // 拖拽上传图片
            e.stopPropagation();
            e.preventDefault();
            let files = e.dataTransfer.files;
            e.target.style.backgroundColor = "transparent";
            if (files.length > 0) {
                let view = window["_view"];
                if (!view) return;
                if (flag === "img") {
                    this.addImgsToLib(files);
                } else if (flag === "svg") {
                    if (files[0].type !== "image/svg+xml") {
                        this.$edMessage.error(this.$t("dragSvgError"));
                    } else {
                        this.addSvgsToLib(files);
                    }
                }
            }
        }
        addPicture(e: MouseEvent, flag: string = "img") {
            let view = window["_view"];
            if (!(<HTMLInputElement>e.srcElement).files.length || !view) return;
            if (flag === "img") {
                this.addImgsToLib((<HTMLInputElement>e.srcElement).files);
            } else {
                this.addSvgsToLib((<HTMLInputElement>e.srcElement).files);
            }
        }
        addImgsToLib(files) {
            // 添加多个图片到库
            let userInfo = this.$store.state.user.userInfo;
            let ts: any = this;
            window["_view"].addImgToLibrary(files).then((insertData) => {
                if (this.type !== "toEdit") {
                    this.worker = new Worker(this.userWorkerURL);
                    let updateData = {
                        DBName: this.DBName,
                        tableName: this.TBName,
                        tableID: this.TBID,
                        nowItem: -1,
                        updateType: "addSymbols",
                        insertData: insertData,
                        versionDB: `myDBVersion_${userInfo.user_id}`,
                    };
                    this.worker.postMessage({
                        type: "update",
                        urls: this.urls,
                        data: updateData,
                    });
                    this.worker.onmessage = (e) => {
                        let message = e.data;
                        console.log("addSymbols", message);
                        if (message.type === "updateOK") {
                            this.addOverAction();
                            console.log("success");
                            ts.$bus.$asyncEmit("uploadToCloud", { message }).then((e: any) => {
                                let version = e.data.version;
                                this.worker.postMessage({
                                    type: "setVersion",
                                    urls: this.urls,
                                    data: {
                                        versionDB: `myDBVersion_${userInfo.user_id}`,
                                        tableID: this.TBID,
                                        version,
                                        params: {
                                            updateModified: true,
                                        },
                                    },
                                });
                            });
                            this.sensors.track("libFromImage", {
                                Catalogues: "editFileProcess",
                            });
                            this.sensors.track("libImport", {
                                Catalogues: "editFileProcess",
                                lib_import_type: "libImport-image",
                            });
                        } else if (message.type === "setVersionOK") {
                            this.worker.terminate();
                        }
                    };
                } else {
                    this.$emit("toEdit", insertData);
                    this.close();
                    this.sensors.track("libFromImage", {
                        Catalogues: "editFileProcess",
                    });
                    this.sensors.track("libImport", {
                        Catalogues: "editFileProcess",
                        lib_import_type: "libImport-image",
                    });
                }
            });
        }
        canAddSvg: Boolean = true;
        checkSvgSize(files, resolve) {
            if (files.length > 4) {
                resolve(3);
                return;
            }
            let flag = 0;
            let returnValue = 1;
            let imgLoad = function (url, callback) {
                let img = new Image();
                img.src = url;
                if (img.complete) {
                    callback(img.width, img.height);
                } else {
                    img.onload = function () {
                        callback(img.width, img.height);
                        img.onload = null;
                    };
                }
            };
            let returnBoolean = function (width, height) {
                console.log(width, height);
                if (Number(width) > 1000 || Number(height) > 1000) {
                    returnValue = 2;
                }
                flag++;
                if (flag === files.length) {
                    resolve(returnValue);
                }
                // resolve();
            };
            function readBlobAsDataURL(blob, callback) {
                let a = new FileReader();
                a.onload = function (e) {
                    callback((e.target as any).result);
                };
                a.readAsDataURL(blob);
            }
            let promiseArr = [];

            for (let len = 0; len < files.length; len++) {
                // promiseArr.push(new Promise((resolve, reject)=>{
                //     readBlobAsDataURL(files[len], function (dataurl, resolve){
                //         imgLoad(dataurl, resolve, returnBoolean);
                //     });
                // }))
                readBlobAsDataURL(files[len], function (dataurl, resolve) {
                    imgLoad(dataurl, returnBoolean);
                });
                // console.log(returnValue)
                // debugger
            }
            // let a = true;
            // // Promise.all(promiseArr).then((value)=>{
            // //     if(flag === files.length){
            // //         a = false;
            // //     }
            // // })
            // let b = true
            // while(b){
            //     if(flag === files.length){
            //         a = false;
            //     }
            //     if(!a){
            //         b = false;
            //         return returnValue
            //     }
            // }
        }
        addSvgsToLib(files) {
            // 添加多个SVG到库
            let userInfo = this.$store.state.user.userInfo;
            new Promise((resolve, reject) => {
                this.checkSvgSize(files, resolve);
            }).then((value) => {
                if (value === 1) {
                    let ts: any = this;
                    window["_view"]
                        .addSvgToLibrary(files)
                        .then((insertData) => {
                            if (this.type !== "toEdit") {
                                this.worker = new Worker(this.userWorkerURL);
                                let updateData = {
                                    DBName: this.DBName,
                                    tableName: this.TBName,
                                    tableID: this.TBID,
                                    nowItem: -1,
                                    updateType: "addSymbols",
                                    insertData: insertData,
                                    versionDB: `myDBVersion_${userInfo.user_id}`,
                                };
                                this.worker.postMessage({
                                    type: "update",
                                    urls: this.urls,
                                    data: updateData,
                                });
                                this.worker.onmessage = (e) => {
                                    let message = e.data;
                                    console.log("addSymbols", message);
                                    if (message.type === "updateOK") {
                                        this.addOverAction();
                                        console.log("success");
                                        ts.$bus.$asyncEmit("uploadToCloud", { message }).then((e: any) => {
                                            let version = e.data.version;
                                            this.worker.postMessage({
                                                type: "setVersion",
                                                urls: this.urls,
                                                data: {
                                                    versionDB: `myDBVersion_${userInfo.user_id}`,
                                                    tableID: this.TBID,
                                                    version,
                                                    params: {
                                                        updateModified: true,
                                                    },
                                                },
                                            });
                                        });
                                        this.sensors.track("libFromImage", {
                                            Catalogues: "editFileProcess",
                                        });
                                        this.sensors.track("libImport", {
                                            Catalogues: "editFileProcess",
                                            lib_import_type: "libImport-svg",
                                        });
                                    } else if (message.type === "setVersionOK") {
                                        this.worker.terminate();
                                    }
                                };
                            } else {
                                this.$emit("toEdit", insertData);
                                this.close();
                                this.sensors.track("libFromImage", {
                                    Catalogues: "editFileProcess",
                                });
                                this.sensors.track("libImport", {
                                    Catalogues: "editFileProcess",
                                    lib_import_type: "libImport-svg",
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            this.$edMessage.error(this.$t("fail"));
                        });
                } else {
                    this.$edMessage.error(this.$t("dragSvgError" + value));
                    (this.$refs.chooseSvg as any).value = "";
                }
            });
        }
        // edt,edl,ede file
        importBtn(type) {
            let edt = this.$refs.edtImporter as HTMLInputElement;
            let edl = this.$refs.edlImporter as HTMLInputElement;
            let img = this.$refs.imgImporter as HTMLInputElement;
            let ede = this.$refs.edeImporter as HTMLInputElement;
            switch (type) {
                case "edt":
                    edt.click();
                    break;
                case "edl":
                    edl.click();
                    break;
                case "img":
                    img.click();
                    break;
                case "ede":
                    ede.click();
                    break;
            }
        }
        getEdt(e) {
            let edt = this.$refs.edtText as HTMLElement;
            edt.innerHTML = e.target.files[0].name;
            this.edt = e.target.files[0];
            e.target.value = null;
        }
        getEdl(e) {
            let edl = this.$refs.edlText as HTMLElement;
            edl.innerHTML = e.target.files[0].name;
            this.edl = e.target.files[0];
            e.target.value = null;
        }
        getImg(e) {
            let img = this.$refs.imgText as HTMLElement;
            img.innerHTML = e.target.files[0].name;
            this.imgFile = e.target.files[0];
            e.target.value = null;
        }
        getEde(e) {
            let ede = this.$refs.edeText as HTMLElement;
            ede.innerHTML = e.target.files[0].name;
            this.edeFile = e.target.files[0];
            e.target.value = null;
        }
        dataURLtoBlob(dataurl) {
            var arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        }
        checkFileName() {
            let edt = this.$refs.edtText as HTMLElement;
            let edl = this.$refs.edlText as HTMLElement;
            let edtName = edt.innerHTML.substring(0, edt.innerHTML.length - 4);
            let edlName = edl.innerHTML.substring(0, edl.innerHTML.length - 4);
            return edlName == edtName && edlName != "";
        }
        confirm() {
            let trackArr = ["uploadImg", "uploadSymbolLibrary", "uploadeSymbol", "uploadSVG"];
            this.$track("mylibrary", "clickimport", `type: ${trackArr[this.activeTab - 1]}`);
            let userInfo = this.$store.state.user.userInfo;
            let ts: any = this;
            if (this.activeTab == 2) {
                if (!this.checkFileName()) {
                    this.showMessage({
                        type: 2,
                        imgType: 2,
                        time: 3,
                        content: this.$t("illegal"),
                    });
                    return;
                }
                this.worker = new Worker(this.userWorkerURL);
                if (this.type !== "toEdit") {
                    let updateData = {
                        DBName: this.DBName,
                        tableName: this.TBName,
                        edl: this.edl,
                        edt: this.edt,
                        tableID: this.TBID,
                        nowItem: -1,
                        updateType: "edledt",
                        versionDB: `myDBVersion_${userInfo.user_id}`,
                    };
                    this.worker.postMessage({
                        type: "update",
                        urls: this.urls,
                        data: updateData,
                    });
                    this.worker.onmessage = (e) => {
                        let message = e.data;
                        if (message.type === "updateOK") {
                            this.addOverAction();
                            console.log("success");
                            ts.$bus.$asyncEmit("uploadToCloud", { message }).then((e: any) => {
                                let version = e.data.version;
                                this.worker.postMessage({
                                    type: "setVersion",
                                    urls: this.urls,
                                    data: {
                                        versionDB: `myDBVersion_${userInfo.user_id}`,
                                        tableID: this.TBID,
                                        version,
                                        params: {
                                            updateModified: true,
                                        },
                                    },
                                });
                            });
                            this.sensors.track("libImport", {
                                Catalogues: "editFileProcess",
                                lib_import_type: "libImport-edt",
                            });
                        } else if (message.type === "setVersionOK") {
                            this.worker.terminate();
                            // ts.$bus.$emit("uploadToCloud", { message });
                        }
                    };
                } else {
                    this.worker.postMessage({
                        type: "handlerEdlEdt",
                        urls: this.urls,
                        data: {
                            edl: this.edl,
                            edt: this.edt,
                        },
                    });
                    this.worker.onmessage = (e) => {
                        let message = e.data;
                        if (message.type === "handlerEdlEdtOK") {
                            this.$emit("toEdit", message.data);
                            this.close();
                            this.sensors.track("libImport", {
                                Catalogues: "editFileProcess",
                                lib_import_type: "libImport-edt",
                            });
                        }
                    };
                }
            } else if (this.activeTab == 3) {
                let fileExtName = `${this.edeFile?.name?.split(".")?.pop()?.toLowerCase()}`;
                if (!this.imgFile || !this.edeFile || fileExtName !== "ede") {
                    this.showMessage({
                        type: 2,
                        imgType: 2,
                        time: 3,
                        content: this.$t("illegalEDE"),
                    });
                    return;
                }
                let promistList = [];
                let dbObj = {
                    name: this.symbolName || "symbol",
                };
                // ede
                let reader = new FileReader();
                reader.readAsText(this.edeFile);
                let promise = new Promise((resolve, reject) => {
                    reader.onload = (e) => {
                        let dataArr = (<any>e.target).result.match(/\<\!\-\-([\s\S]*?)\-\-\>/g);
                        dbObj["data"] = dataArr[0].replace(/(<!--)|(-->)/g, "");
                        dbObj["parent"] = this.TBName;
                        resolve();
                    };
                });
                // img file to blob
                promistList.push(promise);
                let reader2 = new FileReader();
                reader2.readAsDataURL(this.imgFile);
                let promise2 = new Promise((resolve, reject) => {
                    reader2.onload = (e) => {
                        let blob = this.dataURLtoBlob((e.target as FileReader).result);
                        dbObj["blob"] = blob;
                        resolve();
                    };
                });
                promistList.push(promise2);
                Promise.all(promistList).then(() => {
                    if (this.type !== "toEdit") {
                        let userInfo = this.$store.state.user.userInfo;
                        let updateData = {
                            DBName: this.DBName,
                            tableName: this.TBName,
                            tableID: this.TBID,
                            nowItem: -1,
                            updateType: "addSymbol",
                            dbObj: dbObj,
                            versionDB: `myDBVersion_${userInfo.user_id}`,
                        };
                        this.worker = new Worker(this.userWorkerURL);
                        this.worker.postMessage({
                            type: "update",
                            urls: this.urls,
                            data: updateData,
                        });
                        this.worker.onmessage = (e) => {
                            let message = e.data;
                            if (message.type === "updateOK") {
                                this.addOverAction();
                                console.log("success");
                                ts.$bus.$asyncEmit("uploadToCloud", { message }).then((e: any) => {
                                    let version = e.data.version;
                                    this.worker.postMessage({
                                        type: "setVersion",
                                        urls: this.urls,
                                        data: {
                                            versionDB: `myDBVersion_${userInfo.user_id}`,
                                            tableID: this.TBID,
                                            version,
                                            params: {
                                                updateModified: true,
                                            },
                                        },
                                    });
                                });
                                this.sensors.track("libImport", {
                                    Catalogues: "editFileProcess",
                                    lib_import_type: "libImport-ede",
                                });
                            } else if (message.type === "setVersionOK") {
                                this.worker.terminate();
                                // ts.$bus.$emit("uploadToCloud", { message });
                            }
                        };
                    } else {
                        this.$emit("toEdit", [dbObj]);
                        this.close();
                        this.sensors.track("libImport", {
                            Catalogues: "editFileProcess",
                            lib_import_type: "libImport-ede",
                        });
                    }
                });
            }
        }

        mounted() {
            if (this.from == "titleClick") this.activeTab = 3;
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "导入",
    "uploadImg": "图片上传",
    "uploadSvg": "SVG上传",
    "uploadFile": "符号库上传",
    "uploadEde": "符号上传",
    "dragImage": "将您的图片拖动到此处",
    "dragSvg": "将您的SVG拖动到此处",
    "dragSvgError": "请确保您拖拽的文件为svg图片",
    "dragSvgError2": "拖拽的svg图片像素高度或宽度超过1000px",
    "dragSvgError3": "拖拽的svg图片数量不应超过4个",
    "or": "或",
    "selectLocalImage": "选择本地图片",
    "selectLocalSvg": "选择本地SVG",
    "edtfile": "edt文件",
    "edlfile": "edl文件",
    "imgfile": "图片文件",
    "edefile": "ede文件",
    "importBtn": "浏览",
    "confirm": "确定",
    "cancel": "取消",
    "illegal": "请选择正确的edl及edt文件",
    "illegalEDE": "请选择正确的ede及图片文件",
    "symbolName": "符号名称",
    "fail": "错误"
  },
  "en": {
    "title": "Insert Image",
    "uploadImg": "Upload Image",
    "uploadSvg": "Upload SVG",
    "uploadFile": "Upload  Symbol Library",
    "uploadEde": "Upload Symbol",
    "dragImage": "Drag Your Image Here",
    "dragSvg": "Drag Your SVG Here",
    "dragSvgError": "Please make sure that the file you drag is an SVG image",
    "dragSvgError2": "The height or width of the dragged SVG image exceeds 1000 pixels",
    "dragSvgError3": "No more than 4 SVG images to drag and drop",
    "or": "Or",
    "selectLocalImage": "Select Local Image",
    "selectLocalSvg": "Select Local SVG",
    "edtfile": "*.edt file",
    "edlfile": "*.edl file",
    "imgfile": "Image File",
    "edefile": "*.ede File",
    "importBtn": "Browse",
    "confirm": "OK",
    "cancel": "Cancel",
    "illegal": "Please select the correct EDL and EDT files",
    "illegalEDE": "Please select the correct EDE and Image files",
    "symbolName": "Symbol Name",
    "fail": "Failure"
  },
  "jp": {
    "title": "画像を挿入",
    "uploadImg": "画像をアップロード",
    "uploadSvg": "SVGをアップロード",
    "uploadFile": "ローカル画像",
    "uploadEde": "記号をアップロード",
    "dragImage": "画像をここにドラッグ",
    "dragSvg": "ここにSVGをドラッグします",
    "dragSvgError": "ドラッグしたファイルがsvg画像であることを確認してください。",
    "dragSvgError2": "The height or width of the dragged SVG image exceeds 1000 pixels",
    "dragSvgError3": "No more than 4 SVG images to drag and drop",
    "or": "または",
    "selectLocalImage": "ローカル画像を選択",
    "selectLocalSvg": "ローカルSVGを選択",
    "edtfile": "edtファイル",
    "edlfile": "edlファイル",
    "imgfile": "画像ファイル",
    "edefile": "edeファイル",
    "importBtn": "参照",
    "confirm": "OK",
    "cancel": "キャンセル",
    "illegal": "正しいedlとedtファイルを選択してください",
    "illegalEDE": "正しいedeと画像ファイルを選択してください",
    "symbolName": "記号名前",
    "fail": "エラー"
  },
  "fr": {
    "title": "Insérer Image",
    "uploadImg": "télécharger une image",
    "uploadSvg": "Télécharger SVG",
    "uploadFile": "Téléverser Fichier",
    "uploadEde": "Téléchargement de symboles",
    "dragImage": "Faites Glisser votre Image Ici",
    "dragSvg": "Faites glisser votre SVG ici",
    "dragSvgError": "Assurez - vous que le fichier que vous faites glisser soit une image SVG",
    "dragSvgError2": "The height or width of the dragged SVG image exceeds 1000 pixels",
    "dragSvgError3": "No more than 4 SVG images to drag and drop",
    "or": "Ou",
    "selectLocalImage": "Sélectionner Image Locale",
    "selectLocalSvg": "Choisissez SVG local",
    "edtfile": "Fichier edt",
    "edlfile": "Fichier edl",
    "imgfile": "Fichier Image",
    "edefile": "Fichier ede",
    "importBtn": "Parcourir",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "illegal": "Veuillez sélectionner les fichiers edl et edt corrects",
    "illegalEDE": "Veuillez sélectionner le bon fichier ede et image",
    "symbolName": "Nom symbolique",
    "fail": "Erreur"
  },
  "de": {
    "title": "Bild eingeben",
    "uploadImg": "Bild hochladen",
    "uploadSvg": "SVG hochladen",
    "uploadFile": "Datei hochladen",
    "uploadEde": "Symbole hochladen",
    "dragImage": "Bild hier hineinziehen",
    "dragSvg": "Ziehen Sie Ihre SVG hierher",
    "dragSvgError": "Bitte stellen Sie sicher, dass die Datei, die Sie ziehen, ein SVG-Bild ist.",
    "dragSvgError2": "The height or width of the dragged SVG image exceeds 1000 pixels",
    "dragSvgError3": "No more than 4 SVG images to drag and drop",
    "or": "Oder",
    "selectLocalImage": "Lokales Bild auswählen",
    "selectLocalSvg": "Wählen Sie lokale SVG",
    "edtfile": "*.edt Datei",
    "edlfile": "*.edl Datei",
    "imgfile": "Bilddatei",
    "edefile": "*.ede File",
    "importBtn": "Browsen",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "illegal": "Bitte wählen Sie die richtigen edl- und edt-Dateien aus",
    "illegalEDE": "Bitte wählen Sie die richtigen ede und Bild-Dateien aus",
    "symbolName": "Symbolsname",
    "fail": "Fehler"
  },
  "es": {
    "title": "Insertar imagen",
    "uploadImg": "cargar imagen",
    "uploadSvg": "Subir SVG",
    "uploadFile": "Subir archivo",
    "uploadEde": "Cargar símbolo",
    "dragImage": "Arrastre su imagen aquí",
    "dragSvg": "Arrastra tu SVG aquí",
    "dragSvgError": "Por favor, asegúrese de arrastrar el archivo para la imagen SVG",
    "dragSvgError2": "The height or width of the dragged SVG image exceeds 1000 pixels",
    "dragSvgError3": "No more than 4 SVG images to drag and drop",
    "or": "O",
    "selectLocalImage": "Selecciona imagen local",
    "selectLocalSvg": "Elija SVG local",
    "edtfile": "Alchivo edt",
    "edlfile": "Alchivo edl",
    "imgfile": "Archivo de imagen",
    "edefile": "Archivo *.ede",
    "importBtn": "Examinar",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "illegal": "Selecciona los archivos EDL y EDT correctos",
    "illegalEDE": "Selecciona los archivos de imagen y EDE correctos",
    "symbolName": "Nombre",
    "fail": "Fallo"
  },
  "pt": {
    "title": "Inserir Imagem",
    "uploadImg": "Enviar Imagem",
    "uploadSvg": "Upload SVG",
    "uploadFile": "Carregar Ficheiro",
    "uploadEde": "Upload de símbolo",
    "dragImage": "Arrastar a Imagem Aqui",
    "dragSvg": "Arraste seu SVG aqui",
    "dragSvgError": "Por favor, certifique-se de que o arquivo que você arrastar é UMA Imagem SVG",
    "dragSvgError2": "The height or width of the dragged SVG image exceeds 1000 pixels",
    "dragSvgError3": "No more than 4 SVG images to drag and drop",
    "or": "Ou",
    "selectLocalImage": "Selecionar Imagem Local",
    "selectLocalSvg": "Escolha o SVG local",
    "edtfile": "Ficheiro *.edt",
    "edlfile": "Ficheiro *.edl",
    "imgfile": "Ficheiro de Imagem",
    "edefile": "Ficheiro *.ede",
    "importBtn": "Navegar",
    "confirm": "OK",
    "cancel": "Cancelar",
    "illegal": "Selecionar os arquivos EDL e EDT corretos",
    "illegalEDE": "Selecionar os arquivos EDE e de imagem corretos",
    "symbolName": "Nome",
    "fail": "Falha"
  },
  "it": {
    "title": "Inserisci Immagine",
    "uploadImg": "carica immagine",
    "uploadSvg": "Carica file in formato SVG",
    "uploadFile": "Carica File",
    "uploadEde": "Simbolo di Caricamento",
    "dragImage": "Trascina Qui la Tua Immagine",
    "dragSvg": "Trascina qui il tuo SVG",
    "dragSvgError": "Assicurati che il file che trascina sia un'immagine SVG",
    "dragSvgError2": "The height or width of the dragged SVG image exceeds 1000 pixels",
    "dragSvgError3": "No more than 4 SVG images to drag and drop",
    "or": "O",
    "selectLocalImage": "Seleziona un'Immagine Locale",
    "selectLocalSvg": "Scegli SVG locale",
    "edtfile": "File *.edt",
    "edlfile": "File *.edl",
    "imgfile": "File Immagine",
    "edefile": "File *.ede",
    "importBtn": "Sfoglia",
    "confirm": "OK",
    "cancel": "Annulla",
    "illegal": "Seleziona i file edl e edt corretti",
    "illegalEDE": "Seleziona il file ede e l'immagine corretti",
    "symbolName": "Nome simbolico",
    "fail": "Fallimento"
  },
  "tw": {
    "title": "導入",
    "uploadImg": "圖片上傳",
    "uploadSvg": "SVG上傳",
    "uploadFile": "符號庫上傳",
    "uploadEde": "符號上傳",
    "dragImage": "將您的圖片拖動到此處",
    "dragSvg": "將您的SVG拖動到此處",
    "dragSvgError": "請確保您拖拽的檔案為svg圖片",
    "dragSvgError2": "The height or width of the dragged SVG image exceeds 1000 pixels",
    "dragSvgError3": "No more than 4 SVG images to drag and drop",
    "or": "或",
    "selectLocalImage": "選擇本地圖片",
    "selectLocalSvg": "選擇本地SVG",
    "edtfile": "edt檔案",
    "edlfile": "edl檔案",
    "imgfile": "圖片檔案",
    "edefile": "ede檔案",
    "importBtn": "瀏覽",
    "confirm": "確定",
    "cancel": "取消",
    "illegal": "請選擇正確的edl及edt檔案",
    "illegalEDE": "請選擇正確的ede及圖片檔案",
    "symbolName": "符號名稱",
    "fail": "錯誤"
  },
  "kr": {
    "title": "가져오기",
    "uploadImg": "이미지 업로드",
    "uploadSvg": "SVG 업로드",
    "uploadFile": "심볼 라이브러리 업로드",
    "uploadEde": "심볼 업로드",
    "dragImage": "이미지를 여기로 끌어다 놓으세요",
    "dragSvg": "SVG를 여기로 끌어다 놓으세요",
    "dragSvgError": "끌어당긴 파일이 SVG 이미지인지 확인하세요.",
    "dragSvgError2": "끌어온 SVG 이미지의 높이 또는 너비가 1000픽셀을 초과합니다.",
    "dragSvgError3": "끌어당기는 svg 이미지 수량이 4개를 초과해서는 안 됩니다",
    "or": "또는",
    "selectLocalImage": "로컬 이미지 선택",
    "selectLocalSvg": "로컬 SVG 선택",
    "edtfile": "edt 파일",
    "edlfile": "edl 파일",
    "imgfile": "이미지 파일",
    "edefile": "ede 파일",
    "importBtn": "브라우즈",
    "confirm": "확인 ",
    "cancel": "취소",
    "illegal": "올바른 EDL 및 EDT 파일을 선택하세요.",
    "illegalEDE": "올바른 EDE 및 이미지 파일을 선택하세요.",
    "symbolName": "심볼 이름",
    "fail": "실패"
  }
}
</i18n>
